import { getUserNotificationCounter, setUserNotificationCounter } from '../storage.service';

export class UserNotificationCounterKeyService {

  get userNotificationCounterKey() {
    return getUserNotificationCounter;
  }

  setUserNotificationCounterKey(userNotificationKeyValue: any) {
    setUserNotificationCounter(userNotificationKeyValue);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/visual/user-notification-counter-key.service.ts